<template>
  <div>   
    <div v-if="msg" class="facebook-post-preview-body-advanced__message" v-html="msg"></div>
    <a 
      v-if="link"    
      :href="link"
      target="_blank"
      class="facebook-post-preview-body-advanced__link"
    >
      {{ link }}
    </a>
    <shared-social-post-preview-image
      v-if="image"
      title="Post Image Preview"
      :image="image"
      class="facebook-post-preview-body-advanced__image"
    />  
  </div>
</template>

<script>
import {extractSocialPostStepPieces} from '../../mixins/extractSocialPostStepPieces.mixin';
import SharedSocialPostPreviewImage from '../shared/SharedSocialPostPreviewImage';

export default {
  mixins: [extractSocialPostStepPieces],
  components: {    
    SharedSocialPostPreviewImage
  },
  props: {
    pieces: Array,
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../../sass/web/_variables';

.facebook-post-preview-body-advanced {
  &__message {
    color: $black-color;
    line-height: 20px;
    margin-bottom: 5px;
  }
  &__message,
  &__link {
    padding: 0 15px;
    word-break: break-word;
    font-size: 15px;
  }

  &__link {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 15px;
    color: #4599ff;
    max-width: 80%;
    margin-bottom: 10px;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  &__image {
    width: 100%;
  }
}
</style>
